import { version } from '../../package.json';

export const environment = {
   production: true,
   // server_api_url: 'http://localhost:8081',
   server_api_url: 'https://qasigmi.and.gov.co',  //dev
   // server_api_url: 'http://172.30.80.84:8081', //qa
   // CLIENT_ID: 'spa-demoQA', 
   // CLIENT_ID: 'sigmiPRO', // dev
   CLIENT_ID: 'sigmiQA', // qa
   CLIENT_URL: 'https://qaautenticaciondigital.and.gov.co', // local y dev
   // CLIENT_URL: 'https://preautenticaciondigital.and.gov.co', // qa
   RECAPTCHA_KEY: '6LcMK3MeAAAAAPHeZGyUnECTvGCUZh-pQ47KivdP',
   RECAPTCHA_KEY_ACTIVATED: false,
   app_version: version,
   PSA_TABLE_INTEROPERABILITY: '/bodegasigmi/mesas',
   FOLDER_LEVEL_THREE: '/bodegasigmi/niveles/nivel3/solicitudes/normatividad',
   FOLDER_LEVEL_ONE: '/bodegasigmi/niveles/nivelI/solicitudes/normatividad',
   FOLDER_CREATE_DATA: '/bodegasigmi/niveles/nivelI/solicitudes/normatividad',
   FOLDER_LAYERS: '/bodegasigmi/capas',
   FOLDER_LEVEL_THREE_POLITICO: '/bodegasigmi/niveles/nivelIII/solicitudes/politico',
   FOLDER_LEVEL_THREE_ORGANIZACIONAL: '/bodegasigmi/niveles/nivelIII/solicitudes/organizacional',
   FOLDER_LEVEL_THREE_TECNICO: '/bodegasigmi/niveles/nivelIII/solicitudes/tecnico',
};
